import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';

import { deleteMetadataItem } from '../../../store/actions/metadata.actions';

const styles = theme => ({
  icon: {
    marginRight: '5px',
    cursor: 'pointer',
    verticalAlign: 'middle',
    color: theme.palette.grey[500],

    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
});

class DeleteColumnContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete() {
    this.props.deleteMetadataItem(this.props.column.key);
  }

  render() {
    const { column, classes } = this.props;
    if (!column.custom) return null;

    return (
      <Icon
        className={classes.icon}
        onClick={this.handleDelete}
      >
        delete
      </Icon>
    );
  }
}

DeleteColumnContainer.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    custom: PropTypes.bool,
  }).isRequired,
  deleteMetadataItem: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { deleteMetadataItem })(DeleteColumnContainer));
